.root {

  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;

  label {

    display: flex;
    gap: 0.35rem;
    align-items: center;

    .input {
      scale: 1.25;
      &:checked {
        accent-color: var(--cs-origin);
      }
    }

    .label {
      font-weight: normal;
    }
  }
}

.column {
  flex-direction: column;
  align-items: flex-start;
}